import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Button';
import DataItem from 'components/DataItem';
import SectionTitle from 'components/typography/SectionTitle';
import { getPrimaryFromList } from 'shared/helpers/common';
import AddressTabEditModal from './AddressTabEditModal';

export default function AddressTab({ userData = {}, setUserData }) {
  const { moduleConfig = {} } = useSelector((state) => state.settings);
  const [primaryAddress, setPrimaryAddress] = useState({});
  const [isEditModalOpen, setEditModalState] = useState(false);
  const [primaryAddressIndex, setPrimaryAddressIndex] = useState(null);

  useEffect(() => {
    const { addresses = [] } = userData;
    const { data, index } = getPrimaryFromList(addresses, {});
    setPrimaryAddress(data);
    setPrimaryAddressIndex(index);
  }, [userData]);

  const {
    address1,
    address2,
    address3,
    city,
    countyProvince,
    zipOrPostcode,
    country,
  } = primaryAddress;

  return (
    <>
      <SectionTitle label="Address" />
      <div className="lg:mt-[40px] bg-white rounded-t-lg">
        <div className="flex flex-wrap p-4">
          <DataItem
            isVisible={moduleConfig?.['Client-Client-view-address1-visible']}
            label="Address line 1"
            value={address1}
            labelClassName="mb-[20px]"
          />
          <DataItem
            isVisible={moduleConfig?.['Client-Client-view-address2-visible']}
            label="Address line 2"
            value={address2}
            labelClassName="mb-[20px]"
          />
          <DataItem
            isVisible={moduleConfig?.['Client-Client-view-address3-visible']}
            label="Address line 3"
            value={address3}
            labelClassName="mb-[20px]"
          />
          <DataItem
            isVisible={moduleConfig?.['Client-Client-view-city-visible']}
            label="Town / City"
            value={city}
            labelClassName="mb-[20px]"
          />
          <DataItem
            isVisible={
              moduleConfig?.['Client-Client-view-countyProvince-visible']
            }
            label="County"
            value={countyProvince}
            labelClassName="mb-[20px]"
          />
          <DataItem
            isVisible={
              moduleConfig?.['Client-Client-view-zipOrPostcode-visible']
            }
            label="Postcode"
            value={zipOrPostcode}
            labelClassName="mb-[20px]"
          />
          <DataItem
            isVisible={moduleConfig?.['Client-Client-view-country-visible']}
            label="Country"
            value={country}
            labelClassName="mb-[20px]"
          />
        </div>
      </div>
      <div className="bg-white border-t rounded-b-lg flex justify-end">
        <Button className="my-4 mx-6" onClick={() => setEditModalState(true)}>
          <div className="px-6">Edit</div>
        </Button>
      </div>
      {isEditModalOpen && (
        <AddressTabEditModal
          isOpen={isEditModalOpen}
          setModalState={setEditModalState}
          userData={userData}
          setUserData={setUserData}
          primaryAddressIndex={primaryAddressIndex}
          moduleConfig={moduleConfig}
        />
      )}
    </>
  );
}
